import React, { useState, useCallback } from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import MuiToolbar from '@mui/material/Toolbar';
import DrawerContent from '../DrawerContent';
import Routes from '../Routes';
import {
  Root,
  SideDrawer,
  TopAppbar,
  Logo,
  ScrollingContainer,
  Main,
  Title,
  AppBarPlaceholder,
  MenuButton,
  LogoutButton,
  ActionsContainer,
  ThematicLabButton,
  TopToolbar,
} from './styled';
import { Search, BreadCrumbs } from '~/shared/components';
import { Logout, Menu, Launch } from '@mui/icons-material';
import { Auth } from 'aws-amplify';
import config from '~/shared/config';

export default function ClippedDrawer() {
  const [open, setOpen] = useState(true);
  const isDevelopment = true;
  const gotoHomepage = useCallback(() => {
    window.location.href = '/';
  }, []);
  const openThematicLab = useCallback(() => {
    window.open(config.thematicLab.url, '_blank', 'noopener,noreferrer');
  }, []);

  return (
    <Root>
      <CssBaseline />
      <TopAppbar>
        <TopToolbar>
          <MenuButton onClick={() => setOpen(prev => !prev)}>
            <Menu />
          </MenuButton>
          <Logo onClick={gotoHomepage} />
          <BreadCrumbs />
          <Search />
          <Title>Dashoard</Title>
          <ActionsContainer>
            {isDevelopment && (
              <ThematicLabButton
                color="primary"
                variant="outlined"
                startIcon={<Launch fontSize="small" />}
                onClick={openThematicLab}
              >
                Thematic Lab
              </ThematicLabButton>
            )}
            <LogoutButton edge="end" onClick={() => Auth.signOut()}>
              <Logout />
            </LogoutButton>
          </ActionsContainer>
        </TopToolbar>
      </TopAppbar>
      <SideDrawer open={open} variant="permanent">
        <MuiToolbar />
        <ScrollingContainer>
          <DrawerContent />
        </ScrollingContainer>
      </SideDrawer>
      <Main open={open}>
        <AppBarPlaceholder />
        <Routes />
      </Main>
    </Root>
  );
}
